import React, { Component , useState , useEffect  } from 'react';
import {
    Button,
    ButtonGroup,
    UncontrolledButtonDropdown,
    Alert,
    Card,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Row,
    Col,
    UncontrolledAlert
} from "reactstrap";
import PermissionRender from "../../../../../components/PermissionRender/PermissionRender";
import { Permissions } from "../../../../../common/Constants";
import { Formik , Form , Field , ErrorMessage } from "formik";
import TTLProxy from "../../../../../common/TTLAsyncProxy";
import DocumentTitle from 'react-document-title';
import * as yup from 'yup';
import { ExpanderView } from "../../../../../components/AuditExplorer/Elements";
import FormInput from "../../../../../components/FormInput";
import history from '../../../../../history';
import Utils, {runStepAsync} from "../../../../../common/Utils";
import SmartDialog from "../../../../../components/SmartDialog";
import LocationListener from "../../../../../common/LocationListener";
import { css } from 'glamor';
import PropTypes from 'prop-types';
import ProfileAvatar from "../../../../../components/ProfileAvatar";
import _ from 'lodash';
import ImageUploadComponent , { Components as ImageComponents } from "../../../../../components/ImageUploadComponent/ImageUploadComponent";
import Avatar from "react-avatar";
import Icon from "react-icons-kit";
import {ic_close as CloseIcon} from 'react-icons-kit/md/ic_close';
import {Async as AsyncSelect, components} from "react-select";
import ThreeLineItemRender from "../../../../../components/Elements/ThreeLineItemRender";
import {
    CommandAgricEndpoints,
    MediaEndpoints, TractorsEndpoints,
    UsersEndpoints,
    USSDEndpoints
} from "../../../../../common/ProxyEndpoints";
import StandardValue from "../../../../../common/StandardValue";
import DataList from "../../../../../components/TableListView/DataList";
import PlaceHolderDialog from "../../../../../common/PlaceHolderDialog";
import {BasePageTemplate, ImageField, CreateBeneficiaryView, Styles} from '../Elements';
import moment from 'moment';
import {ItemsListView} from "../ItemsListView";
import {getCrops} from "../../../../../data/crops";
import LoadingView from "../../../../../components/Elements/LoadingView";
import {MultiSelectionDialog} from "../../../../../common/MultiSelectionDialog";
import CurrencyLabel from "../../../../../components/CurrencyLabel/CurrencyLabel";
import MDSpinner from "react-md-spinner";
import HTML from "../../../../../common/HtmlHelpers";
import {PaymentMediaTags , ValidationSchemas , generateReference , MIN_VERIFICATION_USERS , uploadProfileImage } from "../Common";
import ErrorView from "../../../../../components/Elements/ErrorView";

/**
 * Create bank payment
 */
class CreateBankPayment extends Component{

    static defaultFormValues = {
        source_name: '',
        source_account_no: '',
        source_location: '',
        source_branch: '',
        source_phone: '',
        source_email: '',
        destination_account_no: '',
        destination_account_type: '',
        creditor_name: '',
        creditor_phone: '',
        creditor_email: '',
        support_assistance_phone: '',
        support_assistance_email: '',
        support_assistance_name: '',
        reference: '',
        currency: process.env.REACT_APP_CURRENCY_CODE,
        total_amount: 100,
        comments: '',
        expires_at: null,
        date_available: null,
        date_issued: null,
        services: [],
        consumers: [],
        verification_users: [],
        documentPhoto: null,
        creditorPhoto: null,
        supportPhoto: null,
        bankPhoto: null
    };

    constructor(props) {
        super(props);

        this.state = {
            isBusy: false,
            services: null,
            registerComplete: false,
            registerPhase: 0,
            registerState: {},
            errorMessage: null,
            initError: null
        };

        this.onSubmit = this.onSubmit.bind(this);
        this.proxy = TTLProxy.getInstance();
        const me = this;

        const getValues = (key) => {

            let values = me._form.getFormikContext().values;

            if(!_.isNil(key))
                return values[key];

            return values;
        };

        this.validationSchema = yup.object().shape({
            source_name: yup.string().required().label("Bank's name"),
            source_account_no: yup.string().label("Source bank account no."),
            source_location: yup.string().label("Bank's location"),
            source_branch: yup.string().required().label("Bank's branch"),
            source_phone: yup.string().test("source_phone","Must be a valid phone number",value => _.isNil(value) || value === '' || Utils.validatePhoneNumber(value, getValues('source_phone-region'))).label("Support assistance phone"),
            source_email: yup.string().label("Source email"),
            destination_account_no: yup.string().required().label("Destination account no."),
            destination_account_type: yup.string().required().label("Destination account type"),
            creditor_name: yup.string().required().label("Creditor's name"),
            creditor_phone: yup.string().required().test("creditor_phone","Must be a valid phone number",value => Utils.validatePhoneNumber(value, getValues('creditor_phone-region') )).label("Creditor's phone"),
            creditor_email: yup.string().email().label("Creditor's email"),
            support_assistance_phone: yup.string().required().test("support_assistance_phone","Must be a valid phone number",value => Utils.validatePhoneNumber(value, getValues('support_assistance_phone-region') )).label("Support personnel's contact"),
            support_assistance_email: yup.string().label("Support personnel's email"),
            support_assistance_name: yup.string().required().label("Support personnel's name"),
            reference: yup.string().required().label("Reference"),
            currency: yup.string().required().label("Currency"),
            total_amount: yup.number().required().min(1).label("Total Amount"),
            comments: yup.string().optional().max(256).label("Comments"),
            expires_at: yup.mixed().optional().label("Expires At"),
            date_available: yup.mixed().optional().label("Date Available"),
            date_issued: yup.mixed().optional().label("Date Issued"),
            services: yup.array(yup.object()).min(1,'Please select services included with payment').label("Services"),
            consumers: yup.array(yup.object()).min(1,`Please select beneficiaries of this payment to proceed`).label("Consumers"),
            verification_users: yup.array(yup.object()).required(`Please select users to verify this payment`).min(MIN_VERIFICATION_USERS,`A minimum of ${MIN_VERIFICATION_USERS} users are required to proceed`).label("Verification Users"),
            documentPhoto: yup.mixed().required('Please upload a valid document photo').label("Document photo"),
            bankPhoto: yup.mixed().optional().label("Bank Photo"),
            creditorPhoto: yup.mixed().optional().label("Creditor Photo"),
            supportPhoto: yup.mixed().optional().label("Support Personnel Photo")
        });

        this._paymentSteps = [
            {
                key: "create-payment",
                run: async (values, state) => {

                    const response = await this.proxy.processRequest(CommandAgricEndpoints.createPayment({

                        ..._.omit(values,[
                            'source_phone-region',
                            'creditor_phone-region',
                            'support_assistance_phone-region',
                            'documentPhoto',
                            'supportPhoto',
                            'creditorPhoto',
                            'bankPhoto'
                        ]),
                        source_phone:  values.source_phone ? Utils.fixPhone(values.source_phone,values['source_phone-region']) : null,
                        creditor_phone: values.creditor_phone ?  Utils.fixPhone(values.creditor_phone,values['creditor_phone-region']) : null,
                        support_assistance_phone: values.support_assistance_phone ? Utils.fixPhone(values.support_assistance_phone,values['support_assistance_phone-region']) : null,

                        services: values.services.map(x => ({
                            service_id: x.instance.id,
                            price_binding: null,
                            comments: null,
                        })),

                        consumers: values.consumers.map(x => ({
                            name: x.farmer.instance.name,
                            phone: x.farmer.instance.phone,
                            email: x.farmer.instance.email,
                            max_amount: x.max_amount,
                            associated_farmer_id: x.farmer.instance.id,
                            reference: {
                                mode: x.reference_mode,
                                value: x.passport_id || x.voters_id || x.national_id || x.drivers_id || x.farmer.instance.phone
                            },
                            comments: x.comments || null
                        })),

                        verification_users: values.verification_users.map(x => ({
                            user_id: x.user.instance.id,
                            comments: x.comments || null,
                            enable_edit: x.enable_edit
                        }))

                    }));

                    if(response.ok){
                        state['payment'] = response.getPayload();
                        return  true;
                    }

                    return false;

                }
            },
            {
                key: "upload-document-photo",
                run: async ({ documentPhoto },{ payment }) => {

                    if(documentPhoto){
                        return await uploadProfileImage(documentPhoto,'cmd_agric_service_payment', payment.id, PaymentMediaTags.DocumentPhoto,false);
                    }

                    return true;
                }
            },
            {
                key: "upload-bank-photo",
                run: async ({ bankPhoto }, { payment }) => {

                    if(bankPhoto){
                        return await uploadProfileImage(bankPhoto,'cmd_agric_service_payment', payment.id , PaymentMediaTags.BankPhoto,false);
                    }

                    return true;

                }
            },
            {
                key: "upload-creditor-photo",
                run: async ({ creditorPhoto }, { payment }) => {

                    if(creditorPhoto){
                        return await uploadProfileImage(creditorPhoto,'cmd_agric_service_payment', payment.id, PaymentMediaTags.CreditorPhoto);
                    }

                    return true;

                }
            },
            {
                key: "upload-support-photo",
                run: async ({ supportPhoto }, { payment }) => {

                    if(supportPhoto){
                        return await uploadProfileImage(supportPhoto,'cmd_agric_service_payment', payment.id , PaymentMediaTags.SupportPhoto);
                    }

                    return true;

                }
            }
        ];

    }

    getForm(){
        this._form.getFormikContext();
    }


    async onSubmit(values){

        const { registerPhase , registerState }  = this.state;

        this.setState({  errorMessage : null });

        const results = await runStepAsync(registerPhase, registerState, values, this._paymentSteps);

        if (results.isComplete) {

            //  toast success
            HTML.toastSuccess('Payment created successfully!');

            //  close dialog
            this.setState({
                registerComplete: true
            }, () => {
                this.handleClose()
            });

        }
        else{

            const state = results.error ? Utils.exceptionToFormErrors(results.error) : null;

            this.setState({
                registerState: results.state,
                registerPhase: results.step,
                errorMessage: _.isNil(results.error) ? null : (state ? state.statusMessage : null),
            }, () => {

                if(state){
                    const _context = this._form.getFormikContext();
                    _context.setErrors(_.pick(state.errors,Object.keys(_context.values)) );
                }


            });

        }

    }

    componentDidMount() {

        //  load state
        this.loadState();
    }

    async loadState(){

        this.setState({ isBusy: true });

        try {

            const [services] = await Promise.all([
                this.proxy.processRequest(USSDEndpoints.getUSSDServices())
            ]);

            this.setState({
                services: services.getPayload()
            });

        }
        catch (e) {

            this.setState({
                initError: e
            });

            HTML.toastError(Utils.getResponseError(e));
        }
        finally {
            this.setState({ isBusy: false });
        }
    }

    handleClose(){
        history.push('/finance/command/agric/payments');
    }

    render() {

        const { isBusy , services }  = this.state;

        return (<DocumentTitle title="CBZ Command Agric - Create Bank Payment">

            <LocationListener block={() =>  this.state.registerComplete ? undefined : 'Are you sure you want to leave page? All changes will be discarded.' }>

                <BasePageTemplate title={<span><i className="fa fa-bank"/> Add Bank Payment</span>}
                                  onClose={this.handleClose}>

                    <PlaceHolderDialog ref={r => this._placeholderDlg = r}/>

                    <MultiSelectionDialog ref={r => this._multiSelectDlg = r}/>

                    <LoadingView isBusy={isBusy}
                                 message={"Preparing form, please hold on..."}>

                        <ErrorView error={this.state.initError}
                                   retryCallback={() => this.loadState()}>

                            <Formik ref={r => this._form = r}
                                    initialValues={CreateBankPayment.defaultFormValues}
                                    validationSchema={this.validationSchema}
                                    onSubmit={async (values,{ setSubmitting }) => {

                                        try {
                                            await this.onSubmit(values);
                                        }
                                        catch (e) {

                                        }
                                        finally {
                                            setSubmitting(false);
                                        }

                                    }}>
                                {({  isSubmitting , isValid , errors , values , setFieldValue , touched , submitCount  }) => {

                                    return <Form>

                                        <Row>

                                            <Col md={6}>

                                                <ExpanderView title="Transaction Info" isExpanded>

                                                    <div className="mt-2">

                                                        <FormInput name={"reference"}
                                                                   title={"Reference"}
                                                                   titleRightContent={<Button color="link" onClick={() => {
                                                                       setFieldValue('reference',generateReference());
                                                                   }}><i className="fa fa-refresh"/> Generate</Button>}
                                                                   type={"text"}
                                                                   icon={"fa fa-key"}
                                                                   placeholder="Enter reference, cheque no. or transaction id here"
                                                                   required/>


                                                        <hr/>
                                                        <Row>

                                                            <Col md={4}>

                                                                <FormInput name={"currency"}
                                                                           title={"Currency"}
                                                                           type={"select"}
                                                                           items={[
                                                                               {
                                                                                   value: process.env.REACT_APP_CURRENCY_CODE,
                                                                                   text:  process.env.REACT_APP_CURRENCY_CODE,
                                                                               }
                                                                           ]}
                                                                           required/>

                                                            </Col>

                                                            <Col md={8}>

                                                                <FormInput name={"total_amount"}
                                                                           title={"Total Amount"}
                                                                           type={"number"}
                                                                           min={1}
                                                                           max={999999999999}
                                                                           icon={"fa fa-money"}
                                                                           placeholder="Enter amount of money deposited"
                                                                           onChange={evt => {

                                                                               let value = Number(evt.target.value);
                                                                               const { items } = this._beneficiaryList.getCallbackProps();
                                                                               if(items.length > 0){

                                                                                   const pVal = values.total_amount;
                                                                                   const ratio = items.map(x => x.max_amount / pVal);
                                                                                   items.forEach((item,i) => {
                                                                                       item.max_amount =  Math.floor(ratio[i] * value);
                                                                                   });

                                                                                   this._beneficiaryList.setItems(items);

                                                                               }

                                                                               setFieldValue('total_amount',value);

                                                                           }}
                                                                           required/>

                                                            </Col>

                                                        </Row>

                                                        <Row>

                                                            <Col md={4}>

                                                                <FormInput name={"date_available"}
                                                                           title={"Date Valid"}
                                                                           type={"datetime"}
                                                                           icon={"fa fa-calendar"}
                                                                           placeholder="Validity date"/>

                                                            </Col>

                                                            <Col md={4}>
                                                                <FormInput name={"date_issued"}
                                                                           title={"Date Issued"}
                                                                           type={"datetime"}
                                                                           icon={"fa fa-calendar"}
                                                                           placeholder="Date issued"/>

                                                            </Col>

                                                            <Col md={4}>

                                                                <FormInput name={"expires_at"}
                                                                           title={"Expiry Date"}
                                                                           type={"datetime"}
                                                                           icon={"fa fa-calendar"}
                                                                           placeholder="Date of expiry"/>

                                                            </Col>

                                                        </Row>



                                                    </div>


                                                </ExpanderView>


                                                <ExpanderView title={<span><i className="fa fa-bank"/> Bank Details</span>} isExpanded>

                                                    <div className="mt-2">

                                                        <FormInput name={"source_name"}
                                                                   title="Bank Name"
                                                                   type="text"
                                                                   placeholder={"Enter bank name here"}
                                                                   required/>



                                                        <FormInput name={"source_branch"}
                                                                   title="Branch"
                                                                   type="text"
                                                                   placeholder={"Enter bank branch"}
                                                                   required/>

                                                        <FormInput name={"source_location"}
                                                                   title="Physical Location / Address"
                                                                   type="text"
                                                                   placeholder={"Enter physical location/address"}
                                                                   required/>

                                                        <hr/>

                                                        <h5>Optional</h5>

                                                        <FormInput name={"source_account_no"}
                                                                   title="Source Account No."
                                                                   type="text"
                                                                   placeholder={"Enter source account no."}
                                                                   required/>

                                                        <FormInput name={"source_phone"}
                                                                   title="Bank/Branch Phone"
                                                                   icon="fa fa-phone"
                                                                   type="phone"
                                                                   placeholder={"Enter bank's phone number"}
                                                                   required/>

                                                        <FormInput name={"source_email"}
                                                                   title="Bank/Branch Email"
                                                                   icon="fa fa-envelope"
                                                                   type="text"
                                                                   placeholder={"Enter bank's email"}
                                                                   required/>


                                                        <h6>Upload Bank Photo</h6>

                                                        <ImageField name={"bankPhoto"}
                                                                    height={180}
                                                                    backgroundColor={"#dfdfdf"}/>

                                                    </div>


                                                </ExpanderView>


                                                <ExpanderView title="Creditor Info" isExpanded>

                                                    <div className="mt-2">

                                                        <Row>

                                                            <Col md={4}>

                                                                <div className="mt-2">
                                                                    <ImageUploadComponent name={Utils.formatAvatarName(values.creditor_name || "CREDITOR")}
                                                                                          size={84}
                                                                                          disabled={false}
                                                                                          onChange={file => {
                                                                                              setFieldValue('creditorPhoto',file);
                                                                                          }}/>
                                                                </div>

                                                            </Col>

                                                            <Col md={8}>
                                                                <FormInput name="creditor_name"
                                                                           type={"text"}
                                                                           title={"Creditor Full Name"}
                                                                           placeholder={"Creditor's full name"}/>

                                                                <FormInput name="creditor_phone"
                                                                           type={"phone"}
                                                                           icon="fa fa-phone"
                                                                           title={"Creditor Phone No."}
                                                                           placeholder={"Enter creditor's phone no."}/>

                                                                <FormInput name="creditor_email"
                                                                           type={"email"}
                                                                           icon="fa fa-envelope"
                                                                           title={"Creditor Email"}
                                                                           placeholder={"Enter creditor's email"}/>
                                                            </Col>

                                                        </Row>


                                                    </div>


                                                </ExpanderView>

                                                <ExpanderView title="Destination Account Info" isExpanded>

                                                    <div className="mt-2">

                                                        <FormInput name="destination_account_no"
                                                                   type={"text"}
                                                                   title={"Destination Account No."}
                                                                   placeholder={"Destination account no."}
                                                                   required/>

                                                        <FormInput name="destination_account_type"
                                                                   type={"text"}
                                                                   title={"Destination Account Type"}
                                                                   placeholder={"Destination account type eg. Savings, Current..."}
                                                                   required/>
                                                    </div>


                                                </ExpanderView>

                                                <ExpanderView title="Support Info" isExpanded>

                                                    <div className="mt-2">

                                                        <Row>

                                                            <Col md={4}>

                                                                <div className="mt-2">
                                                                    <ImageUploadComponent name={Utils.formatAvatarName(values.support_assistance_name || "SUPPORT")}
                                                                                          size={84}
                                                                                          disabled={false}
                                                                                          onChange={file => {
                                                                                              setFieldValue('supportPhoto',file);
                                                                                          }}/>
                                                                </div>

                                                            </Col>


                                                            <Col md={8}>
                                                                <FormInput name="support_assistance_name"
                                                                           type={"text"}
                                                                           title={"Support Assistance Name"}
                                                                           placeholder={"Support assistance name"}
                                                                           required/>

                                                                <FormInput name="support_assistance_phone"
                                                                           type={"phone"}
                                                                           icon="fa fa-phone"
                                                                           title={"Support Assistance Phone"}
                                                                           placeholder={"Support assistance phone"}
                                                                           required/>

                                                                <FormInput name="support_assistance_email"
                                                                           type="text"
                                                                           icon="fa fa-envelope"
                                                                           title={"Support Assistance Email"}
                                                                           placeholder={"Support assistance email"}
                                                                           required/>
                                                            </Col>

                                                        </Row>


                                                    </div>


                                                </ExpanderView>

                                                <hr/>

                                                <h6><i className="fa fa-comment"/> Comments</h6>

                                                <textarea value={values.comments}
                                                          className="form-control form-input mb-2"
                                                          onChange={evt => {
                                                              setFieldValue('comments',evt.target.value);
                                                          }}
                                                          rows={4}
                                                          placeholder="Enter some remarks or comments here"/>

                                            </Col>

                                            <Col md={6}>

                                                <div className="p-2">

                                                    <h6><i className="fa fa-file-o"/> Upload Document Photo</h6>
                                                    <ImageField name={"documentPhoto"}/>
                                                    <ErrorMessage name={"documentPhoto"} className="error-hint text-center" component={"div"}/>

                                                </div>

                                                <hr/>

                                                <ItemsListView title={<span><i className="fa fa-files-o"/>  Tractor Services</span>}
                                                               ref={r => this._serviceList = r}
                                                               emptyMessage={<React.Fragment>
                                                                   <i className="fa fa-file-o fa-2x"/><br/>
                                                                   <p>No services added yet. Click <b>add service</b> to begin</p>
                                                               </React.Fragment>}
                                                               addText={"Add Service"}
                                                               addBtnIcon="fa fa-plus"
                                                               renderMode="table"
                                                               onChange={items => {
                                                                   setFieldValue('services',items)
                                                               }}
                                                               header={() => {

                                                                   return <React.Fragment>

                                                                       {(errors.services && touched.services) && <Alert color="info">
                                                                           <i className="fa fa-info-circle"/> {errors.services}
                                                                       </Alert>}

                                                                   </React.Fragment>
                                                               }}
                                                               columns={[
                                                                   {
                                                                       key: "name",
                                                                       label: "Name",
                                                                       render: item => item.instance.name
                                                                   },
                                                                   {
                                                                       key: "actions",
                                                                       label: "",
                                                                       render: item => {
                                                                           return <ButtonGroup>
                                                                               <Button size="sm" onClick={() => {

                                                                                   if(window.confirm('Remove service?'))
                                                                                       this._serviceList.removeItem(item);

                                                                               }}><i className="fa fa-trash error-hint"/> Remove</Button>
                                                                           </ButtonGroup>
                                                                       }
                                                                   }
                                                               ]}
                                                               onAdd={async ({ items ,  setItems  }) => {

                                                                   this._multiSelectDlg.show(this.state.services.map(x => ({
                                                                           label: x.name ,
                                                                           value: x.id ,
                                                                           instance: x })),
                                                                       items,
                                                                       (values) => {
                                                                           setItems(values);
                                                                       },
                                                                       <span><i className="fa fa-file-o"/> Services</span>,
                                                                       "Please select services to be included",
                                                                       "Add Service(s)"
                                                                   );

                                                               }}/>

                                                <hr/>

                                                <ItemsListView title={<span><i className="fa fa-chevron-right"/> Beneficiaries</span>}
                                                               ref={r => this._beneficiaryList = r}
                                                               emptyMessage={<React.Fragment>
                                                                   <i className="fa fa-smile-o fa-2x"/><br/>
                                                                   <p>No beneficiaries added yet. Click <b>add beneficiary</b> to begin</p>
                                                               </React.Fragment>}
                                                               addText={"Add Beneficiary"}
                                                               renderMode={"table"}
                                                               onChange={items => {
                                                                   setFieldValue('consumers',items)
                                                               }}
                                                               header={({ items }) => {

                                                                   let totalUsed = (_.sumBy(items, x => x.max_amount));
                                                                   let totalRemaining = values.total_amount - totalUsed;

                                                                   return <div>

                                                                       {(errors.consumers && touched.consumers) && <Alert color="info">
                                                                           <i className="fa fa-info-circle"/> {errors.consumers}
                                                                       </Alert>}

                                                                       <Row className={`${Styles.headerCardStyle} p-2`} style={{ backgroundColor: "#efefef" }}>

                                                                           <Col md={6}>

                                                                               <b><i className="fa fa-money"/> Remaining Amount</b>
                                                                               <p>
                                                                                   <CurrencyLabel currency={values.currency}
                                                                                                  value={totalRemaining}/>
                                                                               </p>


                                                                           </Col>

                                                                           <Col md={6}>

                                                                               <b><i className="fa fa-percent"/> Percentage Used</b>
                                                                               <p>{((totalUsed / values.total_amount) * 100).toPrecision(2)}</p>

                                                                           </Col>

                                                                       </Row>

                                                                   </div>



                                                               }}
                                                               columns={[
                                                                   {
                                                                       key: "name",
                                                                       label: "Name",
                                                                       render: (item)=> {
                                                                           return item.farmer.instance.name;
                                                                       }
                                                                   },
                                                                   {
                                                                       key: "identity",
                                                                       label: "Identity",
                                                                       render: item => {

                                                                           switch (item.reference_mode) {
                                                                               case "phone_number":
                                                                                   return item.farmer.instance.phone;
                                                                               case "passport":
                                                                                   return item.passport_id;
                                                                               case "drivers_license":
                                                                                   return  item.drivers_id;
                                                                               case "national_id":
                                                                                   return item.national_id;
                                                                               case "voters_id":
                                                                                   return item.voters_id;
                                                                           }
                                                                       }
                                                                   },
                                                                   {
                                                                       key: "max_amount",
                                                                       label: `Amount (${values.currency})`,
                                                                       render: item => {

                                                                           const items = this._beneficiaryList.getCallbackProps().items;
                                                                           const max = values.total_amount + item.max_amount - _.sumBy(items, x => x.max_amount);

                                                                           return <input name={"max_amount"}
                                                                                         className="form-control form-input"
                                                                                         type="number"
                                                                                         min={0}
                                                                                         max={max}
                                                                                         value={item.max_amount}
                                                                                         onChange={evt => {

                                                                                             let value = Number(evt.target.value);
                                                                                             if(value < 0){
                                                                                                 value = 0;
                                                                                             }
                                                                                             else if(value > max){
                                                                                                 value = max;
                                                                                             }

                                                                                             this._beneficiaryList.updateItem(item,_.merge(item,{
                                                                                                 max_amount: value
                                                                                             }));

                                                                                         }}/>
                                                                       }
                                                                   },
                                                                   {
                                                                       key: "actions",
                                                                       label: "",
                                                                       render: item => {

                                                                           return <ButtonGroup>
                                                                               <Button size="sm" onClick={() => {

                                                                                   if(window.confirm('Remove beneficiary?')){
                                                                                       return this._beneficiaryList.removeItem(item);
                                                                                   }

                                                                               }}><i className="fa fa-trash error-hint"/> Remove</Button>
                                                                           </ButtonGroup>

                                                                       }
                                                                   }
                                                               ]}
                                                               onAdd={async ({ items , addItem , removeItem }) => {

                                                                   this._placeholderDlg.show({
                                                                       title: <span><i className="fa fa-user-plus"/> Add Beneficiary</span>,
                                                                       showCancelButton: false,
                                                                       content: <CreateBeneficiaryView currency={values.currency}
                                                                                                       totalAmount={values.total_amount}
                                                                                                       beneficiaries={items.map(x => x.farmer.instance)}
                                                                                                       remainingAmount={values.total_amount - _.sumBy(items,x => x.max_amount)}
                                                                                                       onSubmit={values => {
                                                                                                            addItem(values);
                                                                                                            this._placeholderDlg.hide();
                                                                                                       }}/>
                                                                   });

                                                               }}/>

                                                <hr/>

                                                <ItemsListView title={<span><i className="fa fa-chevron-right"/> Users (Payment Verification)</span>}
                                                               ref={r => this._usersList = r}
                                                               emptyMessage={<React.Fragment>
                                                                   <i className="fa fa-user fa-2x"/><br/>
                                                                   <p>No users(administrators) added yet. Click <b>add user</b> to begin</p>
                                                               </React.Fragment>}
                                                               addText={"Add User"}
                                                               renderMode={"table"}
                                                               columns={[
                                                                   {
                                                                       key: "name",
                                                                       label: "Name",
                                                                       render: item => {
                                                                           const user = item.user.instance;
                                                                           return Utils.getUserName(user);
                                                                       }
                                                                   },
                                                                   {
                                                                       key: "enable_edit",
                                                                       label: "Enable Edit",
                                                                       render: item => {

                                                                           return <input type="checkbox"
                                                                                         name="enable_edit"
                                                                                         checked={item.enable_edit}
                                                                                         onChange={(evt) => {

                                                                                             this._usersList.updateItem(item,_.merge(item,{
                                                                                                 enable_edit: evt.target.checked
                                                                                             }));

                                                                                         }}/>
                                                                       }
                                                                   },
                                                                   {
                                                                       key: "actions",
                                                                       label: "",
                                                                       render: (item) => {

                                                                           return <ButtonGroup>
                                                                               <Button size="sm" onClick={() => {

                                                                                   if(window.confirm('Remove user?')){
                                                                                       this._usersList.removeItem(item);
                                                                                   }

                                                                               }}><i className="fa fa-trash error-hint"/> Remove</Button>
                                                                           </ButtonGroup>

                                                                       }
                                                                   }
                                                               ]}
                                                               addBtnIcon="fa fa-user-plus"
                                                               onChange={items => {
                                                                   setFieldValue('verification_users',items)
                                                               }}
                                                               header={({ items }) => (<React.Fragment>
                                                                   {(errors.verification_users && touched.verification_users) && <Alert color="info"><i className="fa fa-info-circle"/> {errors.verification_users}</Alert>}
                                                               </React.Fragment>)}
                                                               onAdd={async ({ items ,  addItem , removeItem }) => {

                                                                   const currentUser = TTLProxy.getInstance().getUserInfo();

                                                                   this._placeholderDlg.show({
                                                                       title: <span><i className="fa fa-user-plus"/> Add User</span>,
                                                                       showCancelButton: false,
                                                                       content: <Formik onSubmit={(values,{ setSubmitting}) => {

                                                                           addItem(values);
                                                                           setSubmitting(false);

                                                                           //
                                                                           this._placeholderDlg.hide();
                                                                       }}
                                                                                        validationSchema={ValidationSchemas.AddUser}
                                                                                        initialValues={{
                                                                                            user: null,
                                                                                            enable_edit: false,
                                                                                            comments: ''
                                                                                        }}>

                                                                           {({ isValid , values , setFieldValue , isSubmitting }) => {

                                                                               return <Form>

                                                                                   <b>Administrator</b>
                                                                                   <p>Select administrator to confirm this payment</p>
                                                                                   <AsyncSelect  name="user"
                                                                                                 cacheOptions
                                                                                                 defaultOptions
                                                                                                 placeholder="Search administrator..."
                                                                                                 value={values.user}
                                                                                                 isOptionDisabled={option => items.find(x => x.user.instance.id === option.instance.id) || option.instance.admin.super_user || option.instance.admin.id === currentUser.admin.id}
                                                                                                 onChange={value => {
                                                                                                     setFieldValue('user',value);
                                                                                                 }}
                                                                                                 components={{
                                                                                                     Option: ({ children , ...props }) => {

                                                                                                         const user = props.data.instance;
                                                                                                         return <components.Option {...props}>

                                                                                                             <ThreeLineItemRender media={user.media}
                                                                                                                                  line1Value={Utils.getUserName(user)}
                                                                                                                                  line2Prefix="Phone"
                                                                                                                                  line2Value={user.phone}
                                                                                                                                  line3Prefix="Email"
                                                                                                                                  line3Value={<StandardValue value={user.email}/>}/>

                                                                                                         </components.Option>

                                                                                                     }
                                                                                                 }}
                                                                                                 loadOptions={async (value) => {

                                                                                                     try {

                                                                                                         const res = await this.proxy.processRequest(UsersEndpoints.getByRole('admin').url, {
                                                                                                             search: { keyword: value , method: 'inside', fields: [
                                                                                                                     'username' ,
                                                                                                                     'email',
                                                                                                                     'phone' ,
                                                                                                                     'admin.name',
                                                                                                                 ]},
                                                                                                             pagination: { page: 1 , perPage : 5 },
                                                                                                             include: [ 'media' , 'admin' ]
                                                                                                         });

                                                                                                         return res.getPayload().map(t => ({ label: Utils.getUserName(t), value: t.id  , instance: t }));
                                                                                                     }
                                                                                                     catch (e) {

                                                                                                         // failed to load query

                                                                                                     }

                                                                                                 }}/>


                                                                                   <div className="mt-4">
                                                                                       <h6><i className="fa fa-cogs"/> Permissions</h6>
                                                                                       <div>

                                                                                           <label>Grant Edit Access: <input name="enable_edit"
                                                                                                                            type="checkbox"
                                                                                                                            className="ml-1"
                                                                                                                            onChange={evt => {
                                                                                                                                setFieldValue('enable_edit',evt.target.checked)
                                                                                                                            }}
                                                                                                                            checked={values.enable_edit}/>
                                                                                           </label>

                                                                                       </div>
                                                                                   </div>



                                                                                   <hr/>


                                                                                   <h6><i className="fa fa-comment"/> Comments</h6>
                                                                                   <textarea name={"comments"}
                                                                                             className="form-control form-input"
                                                                                             placeholder="Enter some remarks or comments here"
                                                                                             value={values.comments}
                                                                                             onChange={evt => {
                                                                                                 setFieldValue('comments',evt.target.value)
                                                                                             }}
                                                                                             rows={4}/>

                                                                                   <hr/>

                                                                                   <Button color="green" block disabled={!isValid || isSubmitting}><i className="fa fa-plus"/> Add User</Button>

                                                                               </Form>

                                                                           }}
                                                                       </Formik>
                                                                   });

                                                               }}/>


                                            </Col>

                                        </Row>

                                        {this.state.errorMessage && <UncontrolledAlert color={"danger"}><i className="fa fa-close"/> {this.state.errorMessage}</UncontrolledAlert>}

                                        <hr/>

                                        <div className="clearfix">

                                            <div className="pull-left">
                                                {isSubmitting && <MDSpinner size={32}/>}
                                            </div>

                                            <div className="pull-right">
                                                <span><Button color="green" disabled={isSubmitting} ><i className="fa fa-plus"/> Create Payment</Button></span>
                                                <span><Button className="ml-2" disabled={isSubmitting} onClick={this.handleClose}><i className="fa fa-close error-hint" /> Cancel</Button></span>
                                            </div>

                                        </div>

                                    </Form>
                                }}
                            </Formik>

                        </ErrorView>


                    </LoadingView>

                </BasePageTemplate>

            </LocationListener>

        </DocumentTitle>);
    }


}

export default CreateBankPayment;



// WEBPACK FOOTER //
// ./src/views/Extras/Finance/CommandAgriculture/CreateBankPayment/CreateBankPayment.js